import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { IconButtonComponent } from '@mode/capra';

@Component({
  selector: 'mode-layout-with-collapsible-pane',
  template: `
    <ng-content select="[main-content]"></ng-content>
    <div class="container" data-test="details-panel">
      <div class="header" [class]="{ collapsed: !openPane }">
        <span *ngIf="openPane" data-test="title">DETAILS</span>
        <capra-icon-button
          class="toggle-button"
          (click)="openPane = !openPane"
          aria-label="detail sidebar toggle"
          icon="icon-collapse-panel"
          size="large"
          [class]="openPane ? 'icon-collapse-panel-right' : 'icon-collapse-panel-left'"
        ></capra-icon-button>
      </div>
      <ng-content select="[collapsible-pane]" *ngIf="openPane"></ng-content>
      <ng-container *ngIf="!openPane">
        <span class="collapsed-pane"> DETAILS </span>
      </ng-container>
    </div>
  `,
  styleUrls: ['./layout-with-collapsible-pane.component.scss'],
  standalone: true,
  imports: [CommonModule, IconButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutWithCollapsiblePaneComponent {
  public openPane = true;

  @HostBinding('class.collapsed')
  public get collapsed(): boolean {
    return !this.openPane;
  }
}
